import { Typography, MenuItem } from "@mui/material";
import { tss } from "tss-react";
import { useEffect } from "react";
import { CustomSelectList } from "components";
import { getCachedData } from "api/Cache";
import { sortArrayByProp } from "services/UtilsService";
import commonStyles from "styles/common";
import { trackEvent } from "./Tracking";
import { useLocation  } from 'react-router-dom';
import { useSelector } from 'react-redux';

const useStyles = tss.create((theme) => ({
    label: {
        width: 220,
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        cursor: "pointer",
    },
    projectsLabel: {
        textAlign: "right",
        marginRight: '10 !important',
        width: "max-content",
        minWidth: "max-content",
    },
    select: {
        width: 220,
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        height: 40,
        borderRadius: '24px !important'
    },
    selected: {
        color: '#FFFFFF',
        backgroundColor:' #3DABE6'
    },
    menuItem: {
        width: 220,
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        cursor: "pointer",
    },
}));

type IProps = {
    projectName: string;
    filter: string;
    selectProject: any;
};

export default function ProjectSelector(props: IProps) {
    const { classes, cx } = useStyles();
    const { classes: common } = commonStyles();
    const data: any = getCachedData();
    const projects: any = data["projects"];
    const sortedProjects: any = sortArrayByProp(Object.values(projects), "name");
    const { projectName, filter, selectProject } = props;
    const location = useLocation();
	const currentPath = location.pathname.replace(/\//g, '');
	const storeAuthData = useSelector((state: any) => state.auth);
    const { defaultProjects } = storeAuthData;
    // Reset the filter when we are on the home page
    /*useEffect(() => {
        !currentPath && projectName !== 'All' && selectProject(null, "all");
    }, [projectName, currentPath])*/
    

    return (
        <div
            style={{ display: "flex", alignItems: "center", justifyItems: "center"}}
            className={data.loaded ? "" : common.disabledEvents}
        >
            <Typography className={classes.projectsLabel}>Project Filter: &nbsp;</Typography>
            <CustomSelectList value={projectName} className={classes.select}>
                <MenuItem
                    value="all"
                    onClick={(evt) => selectProject(evt, "all")}
                    className={cx(classes.menuItem, filter === "all" ? classes.selected : "")}
                >
                    All
                </MenuItem>
                {sortedProjects.filter((item:any) => !defaultProjects.includes(item.ID)).map((project: any) => (
                    <MenuItem
                        key={"menu-" + project.ID}
                        value={project.ID}
                        className={cx(classes.menuItem, filter.includes(project.ID) ? classes.selected : "")}
                        onClick={(evt: any) => {
                            trackEvent("TopMenu", "Filter", project.name);
                            selectProject(evt, project.ID)}
                        }
                    >
                        <Typography className={classes.label}>{project.name}</Typography>
                    </MenuItem>
                ))}
            </CustomSelectList>
        </div>
    );
}
